import { DialogComponent } from '@theme/dialog';
import { ThemeEvents } from '@theme/events';

class ProductDimensions extends DialogComponent {
  #picker;

  connectedCallback() {
    super.connectedCallback();
    this.#picker = this.closest('variant-picker');
    this.#picker?.addEventListener(ThemeEvents.variantSelected, this.#awaitVariant);
    this.#picker?.addEventListener(ThemeEvents.variantUpdate, this.#variantReady);
    this.updatedCallback();
  }

  updatedCallback() {
    super.updatedCallback();
    this.hidden = false;
    this.refs.trigger.disabled = false;
  }

  disconnectedCallback() {
    this.#picker?.removeEventListener(ThemeEvents.variantSelected, this.#awaitVariant);
    this.#picker?.removeEventListener(ThemeEvents.variantUpdate, this.#variantReady);
    if (this.refs.dialog.open) this.closeDialog();
    super.disconnectedCallback();
  }

  #awaitVariant = () => {
    // Horizon replaces this content with the selected variant's server-rendered measurements.
    this.hidden = true;
    this.refs.trigger.disabled = true;
    if (this.refs.dialog.open) this.closeDialog();
  };

  #variantReady = (event) => {
    if (String(event.detail.resource?.id) === this.dataset.variantId) this.updatedCallback();
  };

  showDialog() {
    if (this.hidden || this.refs.trigger.disabled) return;
    super.showDialog();
  }
}

if (!customElements.get('vs-product-dimensions')) {
  customElements.define('vs-product-dimensions', ProductDimensions);
}
